export const nav = {
  groups: {
    cobranca: 'Cobrança',
    vendas: 'Vendas',
    gestao: 'Gestão',
    dados: 'Dados',
    administracao: 'Administração',
  },
  items: {
    carteira: 'Carteira',
    fila: 'Fila do dia',
    acordos: 'Acordos',
    campanhas: 'Campanhas',
    lembretes: 'Lembretes',
    vendas: 'Funil de vendas',
    painel: 'Painel',
    meuPainel: 'Meu painel',
    relatorios: 'Relatórios',
    financeiro: 'Financeiro',
    importacoes: 'Importações',
    duplicidades: 'Duplicidades',
    usuarios: 'Usuários',
    auditoria: 'Auditoria',
    lgpd: 'LGPD',
    configuracoes: 'Configurações',
  },
} as const
